<template>
  <div class="toggle-button" @click="toggle">
    <svg-icon :icon-class="icon" />
    <el-button type="text" size="small" class="name-style">{{ buttonName }}</el-button>
  </div>
</template>

<script>
import {mapMutations} from "vuex"
import ClickButton from "@/components/clickButton/index.vue";
export default {
  name: "toggleButton",
  components: {ClickButton},
  props:{
    defaultIsStow: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      isStow: this.defaultIsStow, // 是否收起
      icon: "",
      buttonName: ""
    }
  },
  created() {
    if(this.isStow){
      this.buttonName = "展开"
      this.icon = "zhankai"
    }else {
      this.buttonName = "收起"
      this.icon = "shouqi"
    }
  },
  methods:{
    ...mapMutations(["setToggle"]),
    toggle(){
      //console.log(this.isStow)
      this.setToggle()
      if(this.isStow){
        this.isStow = false
        this.buttonName = "收起"
        this.icon = "shouqi"
        this.$emit("toggleHandler", {isStow: this.isStow})
      }else {
        this.isStow = true
        this.buttonName = "展开"
        this.icon = "zhankai"
        this.$emit("toggleHandler", {isStow: this.isStow})
      }
      let el = document.querySelector(".custom-table")
      el.setAttribute ( 'data-name' , this.buttonName ) ;
    }
  }
}
</script>

<style scoped lang="less">
.toggle-button{
  cursor: pointer;
  display: flex;
  align-items: center;
  svg{
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
  .name-style {
    font-size:14px;
    font-weight:400

  }
}
</style>